"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const MessageCenterWidget = ({ messageCenterWidgetElement, isTransparent }) => {
    return (0, jsx_runtime_1.jsx)("div", { children: (0, react_1.isValidElement)(messageCenterWidgetElement) && (0, react_1.cloneElement)(messageCenterWidgetElement, { isTransparent }) });
};
exports.default = MessageCenterWidget;
